import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/site";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustMarquee from "@/components/TrustMarquee";
import FloatingCTA from "@/components/FloatingCTA";
import Footer from "@/components/Footer";
import Benefits from "@/sections/Benefits";
import Product from "@/sections/Product";
import Different from "@/sections/Different";
import Story from "@/sections/Story";
import Reviews from "@/sections/Reviews";
import Education from "@/sections/Education";
import BilonaMethod from "@/sections/BilonaMethod";
import Usage from "@/sections/Usage";
import Offer from "@/sections/Offer";
import LeadCapture from "@/sections/LeadCapture";
import Wholesale from "@/sections/Wholesale";
import ComingSoon from "@/sections/ComingSoon";
import Global from "@/sections/Global";
import FAQSection from "@/sections/FAQ";
import Contact from "@/sections/Contact";

export default function Home() {
  const [promo, setPromo] = useState({ active: false, text: "" });

  useEffect(() => {
    axios
      .get(`${API}/settings/promo`)
      .then((r) => setPromo(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="overflow-x-clip bg-ivory font-body text-charcoal">
      {promo.active && (
        <div
          data-testid="promo-top-banner"
          className="fixed inset-x-0 top-0 z-50 flex h-9 items-center justify-center bg-gold px-4 text-center text-[10px] font-bold uppercase tracking-[0.22em] text-forest md:text-[11px] md:tracking-[0.25em]"
        >
          Limited-Time Offer{promo.text ? ` — ${promo.text}` : ""}
        </div>
      )}
      <Navbar promoActive={promo.active} />
      <main className={promo.active ? "pt-9" : ""}>
        <Hero />
        <TrustMarquee />
        <Benefits />
        <Product promo={promo} />
        <Different />
        <Story />
        <Reviews />
        <Education />
        <BilonaMethod />
        <Usage />
        <Offer promo={promo} />
        <LeadCapture />
        <Wholesale />
        <ComingSoon />
        <Global />
        <FAQSection />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
